import { Link } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function CategoryShowcase() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-600 mt-2">按地区与类型筛选，快速找到你想看的剧</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-200/70 hover:bg-primary-500/10 border border-background-200 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-300 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${cat.icon} text-xl text-foreground-700 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}